import React, { useState, useEffect, useMemo } from "react";
import Transaction from "../../pages/Transaction/Transaction";
import { TransactionsController } from "../../controllers";

const TransactionContainer = () => {
  const [loading, setLoading] = useState(false);
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [reverseModal, setReverseModal] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [updateStatusModal, setUpdateStatusModal] = useState(false);

  // useQuery start

  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [currencyCode, setCurrencyCode] = useState("NGN");

  const transactionTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}&currencyCode=${currencyCode}`;
  }, [currentPage, limit, currencyCode]);

  const { isLoading, data, isFetching, refetch } =
    TransactionsController.useGetAllTransactions(
      transactionTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  useEffect(() => {
    const setTransactions = async () => {
      setLoading(true);
      await TransactionsController.getTransactionsAnalysis(
        filterQuery ? filterQuery : ""
      );
      setLoading(false);
    };

    setTransactions();
  }, [filterQuery]);

  const goToUpdateStatus = () => {
    setUpdateStatusModal(true);
  };

  const goToViewMore = () => {
    setViewMoreModal(true);
  };

  const goToReverse = () => {
    setReverseModal(true);
  }

  const closeModal = () => {
    setViewMoreModal(false);
    setReverseModal(false);
    setUpdateStatusModal(false);
  };

  const filterHandler = (query) => {
    setFilterQuery(query);
  };

  return (
    <Transaction
      loading={loading}
      viewMoreModal={viewMoreModal}
      goToViewMore={goToViewMore}
      reverseModal={reverseModal}
      goToReverse={goToReverse}
      updateStatusModal={updateStatusModal}
      goToUpdateStatus={goToUpdateStatus}
      closeModal={closeModal}
      filterHandler={filterHandler}
      loading2={loading2}
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      setCurrencyCode={setCurrencyCode}
      currencyCode={currencyCode}
      refetch={refetch}
    />
  );
};

export default TransactionContainer;
